export default {
  methods: {
    getPageBackgroundStyle() {
      if (this.site_setting.page.background) {
        return {
          backgroundImage: `url(${this.site_setting.page.background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          top: '0',
          left: '0',
          width: '100%',
          zIndex: '0',
        };
      }
      return {};
    },

    getBackgroundStyle() {
      let backgroundImage = "";
      const oldPatterns = ["estrellas", "lunas", "ondas", "happyface", "flor2", "flor", "cuadros", "corazones", "calavazas", "calaberas", "puntos", "play"];
      const pattern = this.site_setting.page.pattern;

      if (pattern) {
        backgroundImage = `https://backend.harmony.fan/storage/backgrounds2/${pattern}.png?v=5`;
      }

      if (this.site_setting.page.background) {
        return {
          backgroundImage: `url(${backgroundImage})`,
        };
      } else {
        const useOldPattern = oldPatterns.includes(pattern);
        const styleProperties = useOldPattern ? { backgroundSize: 'cover' } : {};

        if (typeof this.site_setting.page.color == 'string') {
          return {
            background: `${backgroundImage ? `url(${backgroundImage}), ` : ''}${this.site_setting.page.color}`,
            ...styleProperties
          };
        } else {
          const colorSettings = this.site_setting.page.color || {};
          return {
            background: `${backgroundImage ? `url(${backgroundImage}), ` : ''}linear-gradient(${colorSettings.direction || 'to top'}, ${colorSettings.color1 || '#D4D4D4'}, ${colorSettings.color2 || '#D4D4D4'})`,
            ...styleProperties
          };
        }
      }
    },

    getBackgroundStyleWpp() {
      const backgroundStyle = {
        background: `linear-gradient(${this.site_setting.wppOrEmail.background.direction || 'to top'}, ${this.site_setting.wppOrEmail.background.color1 || '#FF00FF00'}, ${this.site_setting.wppOrEmail.background.color2 || '#FF00FF00'})`,
        backgroundSize: 'cover',
      };
      return backgroundStyle;
    },

    setPattern(value) {
      this.site_setting.page.pattern = value
    },

    setDirection() {
      return [
        'to left',
        'to left top',
        'to top',
        'to right top',
        'to right',
        'to right bottom',
        'to bottom',
        'to left bottom',
      ]
    },

    rotateImage(id) {
      if (this.rotationAngle == 315) {
        this.rotationAngle = 0;
      } else {
        this.rotationAngle += 45;
      }
      const index = this.rotationAngle / 45

      if (id == 0) {
        this.selectGradientColorWpp.direction = this.directions[index]
        this.updatedGradientWpp()
      } else {
        this.selectColorGradient.direction = this.directions[index]
        this.updateGradient()
      }
    },

    updateGradient() {
      this.site_setting.page.color = {
        color1: this.selectColorGradient.a,
        color2: this.selectColorGradient.b,
        direction: this.selectColorGradient.direction
      }
    },

    updatedGradientWpp() {
      this.site_setting.wppOrEmail.background = {
        direction: this.selectGradientColorWpp.direction,
        color1: this.selectGradientColorWpp.a,
        color2: this.selectGradientColorWpp.b
      }
      this.site_setting.wppOrEmail.text.color = this.colorTextWpp
    },

    setPickers() {
      this.selectColorGradient.a = this.site_setting.page.color.color1
      this.selectColorGradient.b = this.site_setting.page.color.color2
      this.selectColorGradient.direction = this.site_setting.page.color.direction
      if (typeof this.site_setting.page.color == 'string') {
        this.selectColorGradient.a = this.site_setting.page.color
        this.selectColorGradient.b = this.site_setting.page.color
        this.selectColorGradient.direction = 'to top'
      }

      if (typeof this.site_setting.style_socials == 'object') {
        this.styleSocial.color = this.site_setting.style_socials.color
        this.styleSocial.border = this.site_setting.style_socials.border
      }
    },

    setPickerWpp() {
      //background
      this.selectGradientColorWpp.direction = this.site_setting.wppOrEmail.background.direction
      this.selectGradientColorWpp.a = this.site_setting.wppOrEmail.background.color1
      this.selectGradientColorWpp.b = this.site_setting.wppOrEmail.background.color2
      //text
      this.colorTextWpp = this.site_setting.wppOrEmail.text.color
    },

    removeBackgroundColor() {
      if (this.select == 'logo') {
        this.site_setting.page.color.color1 = '#D4D4D4'
        this.site_setting.page.color.color2 = '#D4D4D4'
      }
      this.saveSettings()
    }
  }
}
